import React from 'react';

DetailPage.propTypes = {
    
};

function DetailPage(props) {
    return (
        <div>
            <h1>this is detail page</h1>
        </div>
    );
}

export default DetailPage;